import React from 'react';
import type { ToolUseBlock, ToolResultBlock } from '../../store/chatStore';
import { ToolResultErrorBoundary } from './ToolResultErrorBoundary';

interface ToolResultViewProps {
  result: ToolResultBlock;
  toolUse: ToolUseBlock;
  getRenderer: (
    result: ToolResultBlock,
    toolUse: ToolUseBlock,
  ) => React.ComponentType<{
    result: ToolResultBlock;
    toolUse: ToolUseBlock;
  }>;
}

export const ToolResultView: React.FC<ToolResultViewProps> = ({
  result,
  toolUse,
  getRenderer,
}) => {
  const Renderer = getRenderer(result, toolUse);
  return (
    <ToolResultErrorBoundary>
      <Renderer result={result} toolUse={toolUse} />
    </ToolResultErrorBoundary>
  );
};
